module.exports = {"340223100":"籍山镇","340223101":"许镇镇","340223102":"弋江镇","340223103":"三里镇","340223104":"何湾镇","340223105":"工山镇","340223106":"烟墩镇","340223107":"家发镇","340223400":"安徽南陵工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340223.json
// module id = 970
// module chunks = 0